// extracted by mini-css-extract-plugin
export var arrows = "CourseMainContent-module--arrows--tg1V4";
export var button = "CourseMainContent-module--button--uh2cJ";
export var chicken = "CourseMainContent-module--chicken--GMVa7";
export var col1 = "CourseMainContent-module--col1--5szFb";
export var col2 = "CourseMainContent-module--col2--EXJjX";
export var disabled = "CourseMainContent-module--disabled--mD7nA";
export var discussion_wrapper = "CourseMainContent-module--discussion_wrapper--4QraN";
export var hideDesc = "CourseMainContent-module--hideDesc--CygvY";
export var nav_buttons = "CourseMainContent-module--nav_buttons--H2GQT";
export var progress_btn_wrapper = "CourseMainContent-module--progress_btn_wrapper--vAmvA";
export var subtitle = "CourseMainContent-module--subtitle--wbJ2H";
export var title = "CourseMainContent-module--title--0DyKD";
export var title_watched = "CourseMainContent-module--title_watched--N4OII";
export var titles = "CourseMainContent-module--titles--ZHaCu";
export var video_name_wrapper = "CourseMainContent-module--video_name_wrapper--qFjRF";
export var video_wrapper = "CourseMainContent-module--video_wrapper--WDGw2";
export var watched = "CourseMainContent-module--watched--sRfTM";
export var watched_wrapper = "CourseMainContent-module--watched_wrapper--Yeq1e";
export var wrapper = "CourseMainContent-module--wrapper--NVAW-";